export default "__VITE_ASSET__DVyG_dsP__"